import React from "react";
import { connect } from "react-redux";
import NumberFormat from "react-number-format";

import { TooltipP } from "../../../components/tooltip";

// import { Promotion } from "./infocar";

//-- *** PriceSummary Props
//-- car: mode view cardetail
//-- trip: mode view tripdetail
//-- promo: promoCode
//-- Note: promo at cardetail (car === true) must be with openPromoBox, removePromoCode function

const PriceSummary = ({ priceSummary, isSD, title, trip, timeCS, appInit }) => {
	// const priceMode = appInit?.data?.priceMode;

	return (
		<>
		<div className="price-container">
			{title && title !== "" ? trip ? <p className="title">{title}</p> : <h6>{title}</h6> : null}
		
				<>
					{priceSummary.discountPercent > 0 && (
						<div className="price-item discount">
							<TooltipP
								title={"Giá cơ bản"}
								desc={() => (
									<>
										Giá cơ bản là giá tính theo 30 ngày thuê xe & chưa bao gồm khuyến mãi (nếu có)
									</>
								)}
							/>
							<p className="cost">
								<NumberFormat
									value={priceSummary.priceOrigin}
									displayType={"text"}
									thousandSeparator={" "}
									decimalSeparator={","}
									suffix={"đ /tháng"}
								/>
							</p>
						</div>
					)}
					{priceSummary.specialDiscount > 0 && (
						<div className="price-item discount">
							<TooltipP
								title={"Giá cơ bản"}
								desc={() => (
									<>
										Giá cơ bản là giá tính theo 30 ngày thuê xe & chưa bao gồm khuyến mãi (nếu có)
									</>
								)}
							/>
							<p className="cost">
								<NumberFormat
									value={priceSummary.priceOrigin}
									displayType={"text"}
									thousandSeparator={" "}
									decimalSeparator={","}
									suffix={"đ /tháng"}
								/>
							</p>
						</div>
					)}
				
					<div className="price-item">
						<p className="df-align-center">Đơn giá thuê</p>
						{/* <TooltipP
							title={"Đơn giá thuê"}
							desc={() => (
								<>
								
								</>
							)}
						/> */}
						<p className="cost">
							<NumberFormat
								value={ priceSummary.priceSpecial}
								displayType={"text"}
								thousandSeparator={" "}
								decimalSeparator={","}
								suffix={"đ /tháng"}
							/>
						</p>
					</div>

					<div className="line-page" />
					<div className="price-item total">
						<p>Tổng cộng</p>
						<p>
							<NumberFormat
								value={priceSummary.priceSpecial}
								displayType={"text"}
								thousandSeparator={" "}
								decimalSeparator={","}
								suffix={"đ "}
							/>
							x&nbsp;{timeCS}&nbsp;tháng
						</p>
					</div>
		
				</>
		</div>
		<div class="price-final">

		<div className={`price-item deposit`}>
			<p className="font-18 text-primary fontWeight-7">Thanh toán</p>
			
			<p className="cost font-18 text-primary fontWeight-7">
				<NumberFormat
					value={priceSummary.priceSpecial}
					displayType={"text"}
					thousandSeparator={" "}
					decimalSeparator={","}
					suffix={"đ/tháng"}
				/>
			</p>
		</div>
		<p className="font-12 fontWeight-5 deposit-text">Thanh toán theo chù kỳ 30 ngày, lần đầu vào ngày nhận xe.</p>
		</div>
		</>
	);
};


function mapState(state) {
	return {
		appInit: state.appInit,
	};
}

export default connect(mapState)(PriceSummary);
